<template>
  <div>
    <h5 class="mb-4"><strong>Who are you recognising?</strong></h5>

    <div class="section-label">Add people</div>

    <employee-search
      ref="searchRef"
      :program-id="program?.recognition_award_program_id"
      :selected-ids="selectedEmployees.map(e => e.employee_id)"
      :exclude-ids="currentEmployeeId ? [currentEmployeeId] : []"
      @select="$emit('add', $event)"
    />

    <div v-if="selectedEmployees.length > 0" class="selected-tags mt-3">
      <span v-for="emp in selectedEmployees" :key="emp.employee_id" class="selected-tag">
        {{ emp.full_name }}
        <span v-if="emp.picker_subtitle" class="selected-tag__subtitle">&middot; {{ emp.picker_subtitle }}</span>
        <font-awesome-icon :icon="['fal', 'xmark']" class="remove-tag" role="button" @click="$emit('remove', emp)" />
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import EmployeeSearch from '@/pages/recognition/components/EmployeeSearch.vue';
import State from '@/state/State';

defineProps({
  program: {
    type: Object,
    default: null,
  },
  selectedEmployees: {
    type: Array,
    default: () => [],
  },
});

defineEmits(['add', 'remove']);

const searchRef = ref(null);

// An admin cannot award themselves — the API rejects the whole batch — so keep
// them out of the picker rather than surfacing that as a submit-time failure.
const currentEmployeeId = computed(() => State.state.claims?.eid);

const clearSearch = () => searchRef.value?.clearSearch();

defineExpose({ clearSearch });
</script>

<style scoped lang="scss">
@import '@/pages/recognition/styles/give-recognition';

.selected-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
}

.selected-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  background-color: var(--palette-color-default-lighten-95);
  color: var(--palette-color-default);
  border: 1px solid var(--palette-color-default-lighten-90);
  border-radius: 1rem;
}

.selected-tag__subtitle {
  font-weight: 400;
  color: var(--palette-color-default-lighten-30);
}

.remove-tag {
  cursor: pointer;
  opacity: 0.6;

  &:hover {
    opacity: 1;
  }
}
</style>
